module.exports = __webpack_public_path__ + "static/media/operating-market.65267246.png";